import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "tl-grid columns" }
const _hoisted_2 = { style: {"grid-column":"timeline","grid-row":"1"} }
const _hoisted_3 = {
  key: 0,
  class: "rowend"
}
const _hoisted_4 = {
  key: 1,
  class: "rowend"
}
const _hoisted_5 = {
  class: "col w-full",
  style: {"margin-top":"-0.1rem"}
}
const _hoisted_6 = { class: "mtop-01 row" }
const _hoisted_7 = { class: "w-maxC" }
const _hoisted_8 = {
  key: 1,
  class: "mleft-04 border-vl bg-h",
  style: {"padding":"0.0rem 0.8rem 0.0rem 0.8rem"}
}
const _hoisted_9 = { class: "mtop-01 row" }
const _hoisted_10 = { class: "w-maxC" }
const _hoisted_11 = {
  key: 1,
  class: "mleft-04 button-text-max-w border-vl bg-h",
  style: {"padding":"0.07rem 0.8rem 0.07rem 0.8rem","min-height":"1.45rem"}
}
const _hoisted_12 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_13 = {
  key: 1,
  class: "mleft-04 concept-item border-vl bg-h"
}
const _hoisted_14 = { class: "tooltiptext max-w-500 font-s" }
const _hoisted_15 = { class: "z-base" }
const _hoisted_16 = { class: "row gap-06 button-text-max-w" }
const _hoisted_17 = { class: "bg-modal w-maxC" }

import { ref, computed, onMounted, watch, nextTick } from 'vue';
import editMedicDoseUpper from '../editMedic/editMedicDoseUpper.vue';
import editMedicDoseLower from '../editMedic/editMedicDoseLower.vue';
import editConceptName from '../editConcept/editConceptName.vue';
import { useUiStore } from '@/stores/ui';
import { tLineCs, tLineHeader, tLineExpressions } from '@/functions/timeline.js';
import { apiDate } from '@/api/apicommon';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import gen from '@/functions/general.js';
import { getProxyTerm, sortExprByDate, getAssessmentExpressionsOfConceptExpr, getConceptExpressions, sortMedicExprArray } from '@/functions/expression';
import { ApiError, ConceptGroupResponse, FolderPatientApi, PatientCommonExpression } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { getSingleElement } from '@/utils/array-utils';
import { useRoute } from 'vue-router';
import { toastError } from '@/utils/toast-utils';
import { useI18n } from 'vue-i18n';
import { useToast } from 'primevue';
import { AggressorFilter, ExpressionType } from '@/models/folerpatient.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'dashbExprBilan',
  props: {
  isTreatmentDashboard: {
    type: Boolean,
    default: false,
  },
  isVaccineDashboard: {
    type: Boolean,
    default: false,
  }
},
  setup(__props) {

const props = __props

const currentEntryStore = useCurrentEntryStore();
const uiStore = useUiStore();
const route = useRoute();
const {t} = useI18n();
const toast = useToast();

const dropd = ref("");

const folderPatientApi = new FolderPatientApi(medServerApiConfig);

const currCclId = computed(() => {
  const dashboardExpr = uiStore.dashBoardItem
  return currentEntryStore.isExprOfCurrEntry(dashboardExpr)
    ? dashboardExpr.conclusionGroup.conclusionGroupId.toString()
    : null
})

function setPoppedSapExpr(sapExpr) {
  currentEntryStore.setPoppedSapExpr(sapExpr)
}

const closeAndUpdateFct = async () => {
  dropd.value = '';
  exprList.value = await constructExprList();
}

function closeFct(){
  dropd.value = '';
}

const csDate = computed(() => {
  return apiDate(currentEntryStore.currentEntryDate) || new Date()
})

const tlStart = computed(() => {
  const isSap = (uiStore.dashBoardItem?.expressionType === ExpressionType.SubstanceAdministrationPrescription);

  const birthDate = apiDate(currentEntryStore.currentPatient?.birthDate);
  const currDate = new Date();
  const startDate = new Date(currDate.setFullYear(currDate.getFullYear() - 6));
  return (props.isTreatmentDashboard || isSap) ? startDate : birthDate || startDate;
  //TODO: option to set start date on ui
})

const tlEnd = computed(() => {
  let currDate = apiDate(currentEntryStore.currentEntryDate) || new Date()
  return new Date(currDate.setMonth(currDate.getMonth() + 2))
})

const tlColumnArr = computed(() => {
  return tLineHeader(tlStart.value, tlEnd.value)
})

let uiIndex = 1
const lastUiIndex = ref(0);
function setLastUiIndex() {
  lastUiIndex.value = uiIndex + 1
}

function atLeastOneSubstanceMatches(sapConcept, comparisonObject) {
  const keys = ['sctSubstance1', 'sctSubstance2', 'sctSubstance3', 'sctSubstance4', 'sctSubstance5', 'sctSubstance6']
  return keys.some(key => {
    const itemValue = sapConcept.definingSapExpression[key]
    const comparisonValue = comparisonObject.definingSapExpression[key]
    return itemValue !== '' && comparisonValue !== '' && comparisonValue === itemValue
  })
}

function getSubstances(dashboardExpr: any): string[] {
  return Array.from(
    { length: 6 },
    (_, i) => dashboardExpr[`sctSubstance${i + 1}`]
  ).filter((v): v is string => !!v);
}

const exprList = ref([]);

const constructExprList = async () => {
  if (!currentEntryStore.hasCurrentEntry || !currentEntryStore.allExpressions) { return [] }

  //Read Data
  const expressions = gen.deepCopy(currentEntryStore.allExpressions);
  const noPrescrExpressions = expressions.filter(expr => expr.expressionType === "None");

  const dashboardExpr = uiStore.dashBoardItem;
  const isSap = (props.isTreatmentDashboard || (dashboardExpr && dashboardExpr.expressionType && dashboardExpr.expressionType === ExpressionType.SubstanceAdministrationPrescription));

  //Filter out "MedicVaccine"
  let sapMedicsConcepts: ConceptGroupResponse[] = [];

  if (isSap) {
    if(dashboardExpr && dashboardExpr.conceptGroupId) {
      await folderPatientApi.getConceptByPatientAndSubstance({patientId: getSingleElement(route.params.patientId), substances: getSubstances(dashboardExpr)})
      .then((result: ConceptGroupResponse[]) => {
        sapMedicsConcepts = result;
      }).catch((error: ApiError) => {
          toastError(toast, {
              summary: t('common.toast.error'),
              detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
          });
      });
      await  folderPatientApi.getExpressionsByConceptGroupAndPatient({patientId: getSingleElement(route.params.patientId), conceptGroupId: dashboardExpr.conceptGroupId})
        .then((result: PatientCommonExpression[]) => {
          currentEntryStore.allExpressions = result;
        });
    } else {
      await folderPatientApi.getConceptReferentialByPatient({patientId: getSingleElement(route.params.patientId), aggressorFilter: AggressorFilter.MedicSubstance})
        .then((result: ConceptGroupResponse[]) => {
          sapMedicsConcepts = result;
        }).catch((error: ApiError) => {
            toastError(toast, {
                summary: t('common.toast.error'),
                detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
            });
        });
    }
}

  //Valid TL expressions
  let validTLExpressions = noPrescrExpressions.filter(expr => expr.timelineStart !== null && expr.timelineEnd !== null && expr.originalText !== null && expr.originalText !== undefined && expr.originalText !== "");
  validTLExpressions = gen.deepCopy(validTLExpressions);

  //Create Timelines
  uiIndex = 1;
  let ARR = [];

  if (props.isTreatmentDashboard) {
    ARR.push(newTimelineGroup("Treatment", validTLExpressions, [], [...sapMedicsConcepts]));
    setLastUiIndex();
    return ARR;
  } else if (props.isVaccineDashboard) {
    await  folderPatientApi.getExpressions({patientId: getSingleElement(route.params.patientId), aggressorRoot: "MedicVaccine"})
          .then((result: PatientCommonExpression[]) => {
            currentEntryStore.allExpressions = result;
          });
    let vaccineExpressions = currentEntryStore.allExpressions .filter(expr => {return expr.aggressorRoot === "MedicVaccine"});
    ARR.push(newTimelineGroup("Vaccinations", vaccineExpressions,  [...vaccineExpressions], []));
    setLastUiIndex();
    return ARR;
  }

  //Read Data for assessesExpr
  if (!uiStore.dashBoardItem) {return []}

  let assessedConcept: ConceptGroupResponse = null;

  if( currentEntryStore.poppedSapExpr?.conceptGroupId == dashboardExpr.conceptGroupId && currentEntryStore.sapConcept && isSap)  {
    assessedConcept = currentEntryStore.sapConcept;
  } else if (dashboardExpr.conceptGroupId && isSap) {
    await folderPatientApi.getConceptGroupByIdAndPatient({patientId: getSingleElement(route.params.patientId), conceptGroupId: dashboardExpr.conceptGroupId, activeDoseTimingFilter: true})
      .then((result: ConceptGroupResponse) => {
        assessedConcept = result;
      }).catch((error: ApiError) => {
          toastError(toast, {
              summary: t('common.toast.error'),
              detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
          });
      });
  }

  if (isSap && !assessedConcept) return []

  // Concept -> get expr (for Concept TL)
  let noneConceptExpressions = getConceptExpressions(dashboardExpr, noPrescrExpressions);
  noneConceptExpressions = gen.deepCopy(noneConceptExpressions);

  // AssessmentLinks -> get expr (for Proxy-Determnination)
  let linkedExpressions = getAssessmentExpressionsOfConceptExpr(dashboardExpr, noPrescrExpressions);
  // const linkedDoseTimings = getAssessmentDoseTimingsOfConceptExpr(dashboardExpr, noPrescrExpressions, doseTimings)
  // const linkedSapMedicConcepts = linkedDoseTimings.map(doseTiming => findById(sapMedicsConcepts, "conceptGroupId", doseTiming.conceptGroup.conceptGroupId))

  // Recos-Suggestions -> get expr (for Proxy-Determination)
  let recosPresentationExpressions = [];
  let recosEtioExpressions = [];
  let recosComplicExpressions = [];
  const refSheet = !isSap ? currentEntryStore.currSuggestionsForDashboard?.expressions[0]?.refSheet : null;
  if (refSheet) {
    recosPresentationExpressions = [...refSheet.sctPresentation0, ...refSheet.sctPresentation1, ...refSheet.sctPresentation2];
    recosEtioExpressions = [...refSheet.sctEtio0, ...refSheet.sctEtio1, ...refSheet.sctEtio2];
    recosComplicExpressions = [...refSheet.sctComplic0, ...refSheet.sctComplic1, ...refSheet.sctComplic2];
  }

  let sctProxyKeys = recosPresentationExpressions.flatMap((rpe) => rpe.sctProxyKey ).filter( rpe => rpe != undefined);
  sctProxyKeys = [...sctProxyKeys, ...recosEtioExpressions.flatMap((rpe) => rpe.sctProxyKey ).filter( rpe => rpe != undefined)];
  sctProxyKeys = [...sctProxyKeys, ...recosComplicExpressions.flatMap((rpe) => rpe.sctProxyKey ).filter( rpe => rpe != undefined)];


  if(sctProxyKeys?.length) {
    const exprs = await folderPatientApi.getExpressions({
      patientId: currentEntryStore.currentPatientId,
      sctProxyKey: sctProxyKeys,

    });

    if (exprs?.length) {
      validTLExpressions.push(...exprs);
    }
  }

  // Ttt-indication recos
  let recosIndicExpressions = [];
  let recosTreatmExpressions = [];

  // Auto-Suggestions for the presentation of the current-Expression
  let autoPresentationSapMedicConcepts = [];
  let autoPresentationExpressions = [];
  if (isSap) {
    const matchingSubstanceConcepts = sapMedicsConcepts.filter(concept => atLeastOneSubstanceMatches(assessedConcept, concept));
    autoPresentationSapMedicConcepts = [...matchingSubstanceConcepts];
  } else if (dashboardExpr.isMatched) {
    const matchingSiteRootExpr = noPrescrExpressions
      .filter(expr =>
        //Match is same siteRoot (except 'blood')
        expr.siteRoot === dashboardExpr.siteRoot && expr.siteRoot !== 'None' && dashboardExpr.siteRoot!== 'Blood'
        //AND if "Morpho", "Specimen". // OR if aggressed --> only match if same aggressorRootGroup
        && ([dashboardExpr.aggressorRoot, expr.aggressorRoot].includes('Surgery') || dashboardExpr.siteFindingRoot !== "Aggressed" || ((dashboardExpr.siteFindingRoot === "Aggressed" && expr.aggressorRootGroup === dashboardExpr.aggressorRootGroup)))
      );
    const matchingAggressorProxyExpr = noPrescrExpressions
      .filter(expr => expr.sctAggressorProxy !== "" && expr.sctAggressorProxy === dashboardExpr.sctAggressorProxy && dashboardExpr.aggressorRoot!== 'Surgery');
    const matchingConceptExpr = noneConceptExpressions
      .filter(expr => expr.isMatched === true);
    autoPresentationExpressions = [...matchingConceptExpr, ...matchingSiteRootExpr, ...matchingAggressorProxyExpr];
  }

  // Create TL
  ARR.push(await newConceptTimelineGroup(noneConceptExpressions, assessedConcept));
  ARR.push(newTimelineGroup("Context", validTLExpressions, [...linkedExpressions, ...autoPresentationExpressions], [...autoPresentationSapMedicConcepts]));
  ARR.push(newTimelineGroup("Treatment", validTLExpressions, [], [...recosTreatmExpressions]));
  ARR.push(newRecoTimeLineGroup("Presentation", validTLExpressions, [...recosPresentationExpressions]));

  if (isSap) {
    ARR.push(newTimelineGroup("Indication", validTLExpressions,  [...recosIndicExpressions], []));
  } else {
    ARR.push(newRecoTimeLineGroup("Etiology", validTLExpressions, [...recosEtioExpressions]));
  }
  ARR.push(newRecoTimeLineGroup("Complication", validTLExpressions, [...recosComplicExpressions]));

  //Set LastUiIndex and return
  setLastUiIndex();

  return ARR;
}

function initNewTimeLineGroup(type: string) {
  return {
    "type" : type,
    "text" : gen.getAssessementTypeTerm(type),
    "uiIndex" : ++uiIndex,
    "elements" : [],
  }
}

async function newConceptTimelineGroup(allConceptExpressions: any, assessedConcept: ConceptGroupResponse) {
  const type = "Concept";
  let timelineGroup = initNewTimeLineGroup(type);

  //Create conceptExpr
  let conceptExpr = gen.deepCopy(uiStore.dashBoardItem);
  let copiedConceptExpr = gen.deepCopy(uiStore.dashBoardItem);
  conceptExpr.id = gen.newId("dashbProxy", ++uiIndex);

  //Add
  if (conceptExpr.expressionType === ExpressionType.SubstanceAdministrationPrescription) {
    //Add Timeline Items
    let sapConcept: ConceptGroupResponse = assessedConcept;
    const doseTimingExpressions = createDoseTimingExpressionsForConcept(sapConcept);

    conceptExpr.tLineContent = tLineExpressions(doseTimingExpressions, tlStart.value, tlEnd.value);
    //Add edtitables for Sap
    const lastDoseTiming = sapConcept.currentEntryStatus.priorDoseTiming;
    lastDoseTiming.closestExpression = sapConcept.currentEntryStatus.closestExpression;

    lastDoseTiming.closestExpression.dbText = lastDoseTiming.closestExpression.matchedText;
    conceptExpr.editableDoseTimings = [lastDoseTiming];

    //Text
    const latestSapExpr = sapConcept.currentEntryStatus.closestExpression;
    conceptExpr.text = latestSapExpr.matchedText //getProxyTerm(conceptExpr) || latestSapExpr.originalText
    conceptExpr.isSapActive = sapConcept.currentEntryStatus.isSapActive;

    //conceptExpr.text += " " + conceptExpr.sctAdministrationRoute
  } else {
    //Text
    //conceptExpr.text = getInterpretedExprTerm(conceptExpr)
    //Add Timeline Items
    conceptExpr.tLineContent = tLineExpressions(allConceptExpressions, tlStart.value, tlEnd.value);
    //Add lastest and currents expressions
    addEditableAndLatest(conceptExpr, [copiedConceptExpr], type);
  }

  //Push
  timelineGroup.elements.push(conceptExpr);

  return timelineGroup;
}

function addEditableAndLatest(proxyExpr, matchingExprArr, type) {
  if (proxyExpr.expressionType === ExpressionType.SubstanceAdministrationPrescription) {console.error("addLatestAndCurrentExpr should only be used for non SAP"); return;}

  //Filter
  // const currEntryId = currentEntryStore.currentEntryId || ""
  // const matchingArrOnlyCurrentExpr = matchingExprArr.filter(expr => expr.entry.relationshipId === currEntryId && expr.originalText !== "")

  //Add editable expressions
  proxyExpr.editableExpressions = []
  if (type === 'Concept') {
    proxyExpr.editableExpressions = gen.deepCopy(matchingExprArr)
    //Remember dbText
    for (const expr of proxyExpr.editableExpressions) {
      expr.dbText = expr.originalText
    }
  } else {
    //Add matchingExpressions
    if (matchingExprArr.length > 0) {
      const currEntryDate = currentEntryStore.currentEntryDate
      proxyExpr.matchingExpressions = gen.deepCopy(matchingExprArr)
      sortExprByDate(proxyExpr.matchingExpressions)
      proxyExpr.matchingExpressions.forEach(expr => {
        expr.relativeDateText = gen.shortRelativeDate(expr.entry.entryStart, currEntryDate)
      })
    }
  }
}

function createDoseTimingExpressionsForConcept(sapConcept){
  let doseTimingExpressions = [];
  //Get all their doseTimings and convert them to TL-expressions --> closestExpression + doseTiming
  sapConcept?.doseTimings.forEach(doseTiming => {
    let closestExpr = gen.deepCopy(doseTiming.closestExpression)
    //Modifiy Expr
    closestExpr.timelineStart = doseTiming.timelineStart
    closestExpr.timelineEnd = doseTiming.timelineEnd
    closestExpr.isOngoing = true
    if (doseTiming.conceptTimingType === 'Stop') {
      closestExpr.durationType = "Until"
    } else if (doseTiming.conceptTimingType === 'Duration') {
        closestExpr.durationType = "Duration" 
    } else if (doseTiming.conceptTimingType === 'Start') {
      closestExpr.durationType = "Since"
    } else {
      console.error("Found a conceptTimingType that is neither 'Stop' nor 'Start' for SAP, but: " + doseTiming.conceptTimingType)
      closestExpr.durationType = ""
    }
    closestExpr.updated = doseTiming.updated
    //Add DoseTiming Data
    closestExpr.doseTiming = gen.deepCopy(doseTiming)
    //Return
    doseTimingExpressions.push(closestExpr)
  })
  return doseTimingExpressions
}

function newRecoTimeLineGroup(type, validTLExpressions, proxyExpressions) {
  proxyExpressions = gen.deepCopy(proxyExpressions)
  let timelineGroup = initNewTimeLineGroup(type)
  for (const tlProxyExpr of proxyExpressions) {
    if (tlProxyExpr.expressionType !== "None") {console.error("Only 'ExpressionType = None' should be added to tlProxyExpressions: " + tlProxyExpr.originalText);continue;}
    //Get matching TL items
    const matchingExprArr = tlProxyExpr.isMatched
      ? validTLExpressions.filter(expr => expr.sctProxyKey === tlProxyExpr.sctProxyKey)
      : []
    //Add data
    tlProxyExpr.text = tlProxyExpr.originalText
    tlProxyExpr.tLineContent = tLineExpressions(matchingExprArr, tlStart.value, tlEnd.value)
    addEditableAndLatest(tlProxyExpr, matchingExprArr, type)
    //Push
    timelineGroup.elements.push(tlProxyExpr)
  }
  //uiIndex
  for (const tlProxyExpr of timelineGroup.elements) {
    tlProxyExpr.id = gen.newId("dashbProxy", ++uiIndex)
  }
  return timelineGroup
}

function newTimelineGroup(type, validTLExpressions, proxyExpressions, proxySapConcepts) {
  const dashBoardExpr = uiStore.dashBoardItem

  // Timeline Group ('Presentation', 'Etiology', 'Complication', 'Indication', 'Treatment')
  let timelineGroup = initNewTimeLineGroup(type)

  //Create a TL for each sapConcepts
  const addedSapConcepts = new Set()
  for (const proxySapConcept of proxySapConcepts) {
    if (!proxySapConcept.definingSapExpression?.originalText) {console.error("proxySapConcept should have a definingSapExpression with originalText"); continue;}
    //Get definingSapExpression
    let definingSapExpression = gen.deepCopy(proxySapConcept.definingSapExpression)
    //Ensure no Duplicate sapConcepts
    if (addedSapConcepts.has(proxySapConcept.conceptGroupId)) {continue;}
    addedSapConcepts.add(proxySapConcept.conceptGroupId)
    //Ensure no Duplicate of assessedConcept
    if (dashBoardExpr?.conceptGroupId === proxySapConcept.conceptGroupId) {continue;}
    //Add
    const latestSapExpr = proxySapConcept.conceptExpressions[0]
    definingSapExpression.text = latestSapExpr.matchedText // getProxyTerm(definingSapExpression) || latestSapExpr.originalText
    //Add Timeline Items
    const doseTimingExpressions = createDoseTimingExpressionsForConcept(proxySapConcept)
    definingSapExpression.tLineContent = tLineExpressions(doseTimingExpressions, tlStart.value, tlEnd.value)
    //Add editable for Sap
    const lastDoseTiming = gen.deepCopy(proxySapConcept?.currentEntryStatus?.priorDoseTiming);
    if (lastDoseTiming?.closestExpression){
      lastDoseTiming.closestExpression = gen.deepCopy(proxySapConcept?.currentEntryStatus?.closestExpression);
      lastDoseTiming.closestExpression.dbText = lastDoseTiming?.closestExpression?.matchedText;
    }

    definingSapExpression.isSapActive = proxySapConcept?.currentEntryStatus?.isSapActive;

    if (lastDoseTiming) {
      definingSapExpression.editableDoseTimings = [lastDoseTiming];

      //Push
      timelineGroup.elements.push(definingSapExpression);
    }

  }

  //Create a TL for each proxyExpr
  const addedKeys = new Set()
  const addedOriginalTexts = new Set()
  for (const tlProxyExpr of proxyExpressions) {
    if (tlProxyExpr.expressionType !== "None") {
      continue
    }
    //Copy
    const copiedTlProxyExpr = gen.deepCopy(tlProxyExpr)
    // Ensure no Duplicate Proxies
    if (tlProxyExpr.isMatched) {
      if (addedKeys.has(tlProxyExpr.sctProxyKey)) {continue;}
      addedKeys.add(tlProxyExpr.sctProxyKey);
    } else {
      if (addedOriginalTexts.has(tlProxyExpr.originalText)) {continue;}
      addedOriginalTexts.add(tlProxyExpr.originalText);
    }

    //Get matching TL items
    let matchingExprArr = []
    if (tlProxyExpr.isMatched) {   //If expr.isMatched --> filter on sctProxyKey
      matchingExprArr = validTLExpressions.filter(expr => expr.sctProxyKey === tlProxyExpr.sctProxyKey)
    } else if (tlProxyExpr.conclusionGroup?.assessmentExpressionId && tlProxyExpr.originalText !== "") {         //If not matched, but if it is an assessment expression --> add the expression itself
      matchingExprArr = [copiedTlProxyExpr]
    } else{
      //continue;   //In case of a pure reco-expression => don't add it
    }

    //Add Laterality Filter for Presentation
    if (dashBoardExpr && type === "Presentation" && dashBoardExpr.isMatched && ["Left", "Right"].includes(dashBoardExpr.laterality)) {
      tlProxyExpr.text = getProxyTerm(tlProxyExpr, "defaultFirst", dashBoardExpr.laterality) || tlProxyExpr.originalText
      //Filter
      if (dashBoardExpr.laterality === "Left") {
        matchingExprArr = matchingExprArr.filter(expr => expr.laterality !== "Right")
      } else if (dashBoardExpr.laterality === "Right") {
        matchingExprArr = matchingExprArr.filter(expr => expr.laterality !== "Left")
      }
    } else {
      tlProxyExpr.text = getProxyTerm(tlProxyExpr) || tlProxyExpr.originalText
    }
    if (["Etiology", "Complication"].includes(type)) {
      tlProxyExpr.text = tlProxyExpr.originalText
    }

    //Add
    tlProxyExpr.tLineContent = tLineExpressions(matchingExprArr, tlStart.value, tlEnd.value)
    addEditableAndLatest(tlProxyExpr, matchingExprArr, type)

    //Push
    timelineGroup.elements.push(tlProxyExpr)
  }

  //Sort
  if (type === "Treatment") {
    sortMedicExprArray(timelineGroup.elements)
  }

  //uiIndex
  for (const tlProxyExpr of timelineGroup.elements) {
    tlProxyExpr.id = gen.newId("dashbProxy", ++uiIndex)
  }

  return timelineGroup
}

onMounted(async () => {
    exprList.value = await constructExprList();
});


let pendingDropd = "";

watch(() => uiStore.dashBoardItem, () => {
  if (!dropd.value?.startsWith('PosoStarted')) { return; }
  pendingDropd = dropd.value;
  dropd.value = "";
})

watch(exprList, async (list) => {
  if (!pendingDropd || list.length === 0) { return; }
  const target = pendingDropd;
  pendingDropd = "";
  await nextTick();
  dropd.value = target;
})


return (_ctx: any,_cache: any) => {
  const _component_tlLabels = _resolveComponent("tlLabels")!
  const _component_tlColumns = _resolveComponent("tlColumns")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_timeLine = _resolveComponent("timeLine")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_dbGroup = _resolveComponent("dbGroup")!
  const _component_tlCsLine = _resolveComponent("tlCsLine")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tlColumnArr.value, (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_tlLabels, { content: item }, null, 8, ["content"])
        ]),
        _createElementVNode("div", {
          style: _normalizeStyle([{"grid-column":"timeline"}, {'grid-row': '2 / ' + lastUiIndex.value}]),
          class: "events-0"
        }, [
          _createVNode(_component_tlColumns, { content: item }, null, 8, ["content"])
        ], 4)
      ], 64))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exprList.value, (item1, index1) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index1 }, [
        (props.isTreatmentDashboard || item1.elements?.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (item1.type !== 'Concept')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    style: _normalizeStyle([{"grid-column":"pathoName","margin-bottom":"1rem"}, {'grid-row' : item1.uiIndex}]),
                    class: "rowend mtop-25"
                  }, [
                    _createVNode(_component_text_item, {
                      styles: "font-mBold",
                      txt: item1.text
                    }, null, 8, ["txt"]),
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "mleft-06" }, null, -1))
                  ], 4))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item1.elements, (item2, index2) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index2 }, [
                  _createElementVNode("div", {
                    style: _normalizeStyle({'grid-area' : item2.id.uiIndex + ' / pathoName'})
                  }, [
                    (item1.type === 'Concept')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(_component_text_item, {
                            txt: (item2.expressionType === _unref(ExpressionType).SubstanceAdministrationPrescription) ? item2.text : ''
                          }, null, 8, ["txt"]),
                          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "mleft-03" }, null, -1))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_component_text_item, {
                            txt: item2.text,
                            styles: item2.isMatched === true ? 'main-h' : 'main-l'
                          }, null, 8, ["txt", "styles"]),
                          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "mleft-03" }, null, -1))
                        ]))
                  ], 4),
                  _createElementVNode("div", {
                    style: _normalizeStyle({'grid-area' : item2.id.uiIndex + ' / timeline'})
                  }, [
                    _createVNode(_component_timeLine, {
                      content: item2.tLineContent,
                      styles: "bg-bghigh",
                      class: "w-full"
                    }, null, 8, ["content"]),
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "mtop-10" }, null, -1))
                  ], 4),
                  _createElementVNode("div", {
                    style: _normalizeStyle({'grid-area' : item2.id.uiIndex + ' / timeline'})
                  }, [
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.editableDoseTimings, (item3, index3) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index3,
                          class: "z-base row-top",
                          style: {"width":"75%"}
                        }, [
                          (item2.isSapActive !== true)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_unref(currentEntryStore).isEditable)
                                  ? (_openBlock(), _createBlock(_component_dropdownBox, {
                                      key: 0,
                                      modelValue: dropd.value,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dropd).value = $event)),
                                      openOn: 'PosoStopped' + item2.id.uiIndex,
                                      combo: true,
                                      onClick: ($event: any) => (setPoppedSapExpr(item3.closestExpression))
                                    }, {
                                      dropup: _withCtx(() => [
                                        _createVNode(editMedicDoseUpper, {
                                          onClose: _cache[0] || (_cache[0] = ($event: any) => (closeFct()))
                                        })
                                      ]),
                                      dropd: _withCtx(() => [
                                        _createVNode(editMedicDoseLower, {
                                          conclusionId: currCclId.value,
                                          onClose: _cache[1] || (_cache[1] = ($event: any) => (closeFct())),
                                          onClosed: closeAndUpdateFct
                                        }, null, 8, ["conclusionId"])
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_buttonGroup, {
                                          styles: "border-vl bg-h",
                                          class: "mleft-04",
                                          style: {"padding":"0.0rem 0.8rem 0.0rem 0.8rem"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_6, [
                                              _createElementVNode("div", _hoisted_7, [
                                                _createVNode(_component_svg_item, {
                                                  icon: "stop",
                                                  styles: "main-m size-m",
                                                  class: "item-center square-12"
                                                })
                                              ]),
                                              _createVNode(_component_text_item, {
                                                txt: item3?.closestExpression?.matchedText,
                                                class: "main-h w-full mleft-04 button-text-max-w"
                                              }, null, 8, ["txt"])
                                            ])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "openOn", "onClick"]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                      _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, [
                                          _createVNode(_component_svg_item, {
                                            icon: "stop",
                                            styles: "main-m size-m",
                                            class: "item-center square-12"
                                          })
                                        ]),
                                        _createVNode(_component_text_item, {
                                          txt: item3?.closestExpression?.matchedText,
                                          class: "main-h w-full mleft-04 button-text-max-w"
                                        }, null, 8, ["txt"])
                                      ])
                                    ]))
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (_unref(currentEntryStore).isEditable)
                                  ? (_openBlock(), _createBlock(_component_dropdownBox, {
                                      key: 0,
                                      modelValue: dropd.value,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dropd).value = $event)),
                                      openOn: 'PosoStarted' + item2.id.uiIndex,
                                      class: "w-full",
                                      combo: true,
                                      onClick: ($event: any) => (setPoppedSapExpr(item3.closestExpression))
                                    }, {
                                      dropup: _withCtx(() => [
                                        _createVNode(editMedicDoseUpper, {
                                          onClose: _cache[3] || (_cache[3] = ($event: any) => (closeFct()))
                                        })
                                      ]),
                                      dropd: _withCtx(() => [
                                        _createVNode(editMedicDoseLower, {
                                          conclusionId: currCclId.value,
                                          onClose: _cache[4] || (_cache[4] = ($event: any) => (closeFct())),
                                          onClosed: closeAndUpdateFct
                                        }, null, 8, ["conclusionId"])
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_buttonGroup, {
                                          styles: "border-vl bg-h",
                                          class: "mleft-04 button-text-max-w",
                                          style: {"padding":"0.07rem 0.8rem 0.07rem 0.8rem","min-height":"1.45rem"}
                                        }, {
                                          default: _withCtx(() => [
                                            (item3.closestExpression?.multiDosageText)
                                              ? (_openBlock(), _createBlock(_component_text_item, {
                                                  key: 0,
                                                  txt: item3.closestExpression?.multiDosageText,
                                                  class: "main-m button-text-max-w"
                                                }, null, 8, ["txt"]))
                                              : (_openBlock(), _createBlock(_component_text_item, {
                                                  key: 1,
                                                  txt: item3.closestExpression?.matchedText,
                                                  class: "main-h button-text-max-w"
                                                }, null, 8, ["txt"]))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "openOn", "onClick"]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                      (item3.closestExpression?.multiDosageText)
                                        ? (_openBlock(), _createBlock(_component_text_item, {
                                            key: 0,
                                            txt: item3.closestExpression?.multiDosageText,
                                            class: "main-m button-text-max-w"
                                          }, null, 8, ["txt"]))
                                        : (_openBlock(), _createBlock(_component_text_item, {
                                            key: 1,
                                            txt: item3.closestExpression?.matchedText,
                                            class: "main-h button-text-max-w"
                                          }, null, 8, ["txt"]))
                                    ]))
                              ], 64))
                        ]))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.editableExpressions, (item3, index3) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index3,
                          class: "z-base row-top"
                        }, [
                          (item1.type === 'Concept')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                (_unref(currentEntryStore).isEditable)
                                  ? (_openBlock(), _createBlock(_component_dropdownBox, {
                                      key: 0,
                                      modelValue: dropd.value,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dropd).value = $event)),
                                      openOn: 'EditConcept' + item2.id.uiIndex,
                                      combo: true,
                                      onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                                    }, {
                                      dropd: _withCtx(() => [
                                        _createVNode(editConceptName, {
                                          conceptExpression: item3,
                                          onClose: _cache[6] || (_cache[6] = ($event: any) => (closeFct()))
                                        }, null, 8, ["conceptExpression"])
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_buttonGroup, {
                                          styles: "border-vl bg-h",
                                          class: "mleft-04 concept-item"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_text_item, {
                                              txt: item3.originalText,
                                              class: "main-h button-text-max-w"
                                            }, null, 8, ["txt"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "openOn"]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                      _createVNode(_component_text_item, {
                                        txt: item3.originalText,
                                        class: "main-h button-text-max-w"
                                      }, null, 8, ["txt"])
                                    ])),
                                _createElementVNode("span", _hoisted_14, _toDisplayString(item3.originalText), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_15, [
                        (item2.matchingExpressions?.length > 0)
                          ? (_openBlock(), _createBlock(_component_dropdownBox, {
                              key: 0,
                              modelValue: dropd.value,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dropd).value = $event)),
                              openOn: 'MatchingExpressions' + item2.id.uiIndex
                            }, {
                              dropd: _withCtx(() => [
                                _createElementVNode("div", _hoisted_17, [
                                  _createVNode(_component_dbGroup, null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.matchingExpressions, (matchingExpr, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: index,
                                          class: "row gap-06"
                                        }, [
                                          _createVNode(_component_text_item, {
                                            txt: matchingExpr.originalText
                                          }, null, 8, ["txt"]),
                                          _createVNode(_component_text_item, {
                                            txt: matchingExpr.relativeDateText,
                                            class: "main-m font-s"
                                          }, null, 8, ["txt"])
                                        ]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_buttonGroup, {
                                  styles: "pad-s border-vl bg-h rnd-0",
                                  class: "last-expression"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createVNode(_component_text_item, {
                                        txt: item2.matchingExpressions[0].originalText,
                                        class: "main-h"
                                      }, null, 8, ["txt"]),
                                      _createVNode(_component_text_item, {
                                        txt: item2.matchingExpressions[0].relativeDateText,
                                        class: "main-m font-s"
                                      }, null, 8, ["txt"])
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "openOn"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 4)
                ], 64))
              }), 128))
            ], 64))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    _createElementVNode("div", {
      style: _normalizeStyle([{"grid-column":"timeline"}, {'grid-row': '2 / ' + lastUiIndex.value}]),
      class: "events-0"
    }, [
      _createVNode(_component_tlCsLine, {
        content: _unref(tLineCs)(csDate.value, tlStart.value, tlEnd.value)
      }, null, 8, ["content"])
    ], 4)
  ]))
}
}

})